import Swiper from 'swiper';
import { Navigation, Scrollbar } from 'swiper/modules';
import { Fancybox } from "@fancyapps/ui/dist/fancybox/";

// init Swiper:
function initGallerySwiper() {
  const swiper = new Swiper('.swiper', {
    // configure Swiper to use modules
    modules: [Navigation, Scrollbar],
    slidesPerView: 2.3,
    spaceBetween: 10,
    breakpoints: {
      991: {
        slidesPerView: 3,
        spaceBetween: 32,
      },
    },
    loop: false,
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
  });
}

function initGalleryLightbox() {
  Fancybox.bind("[data-fancybox]", {
    Carousel: {
    Toolbar: {
      display: {
        left: [],
        right: ["zoomIn", "autoplay", "fullscreen", "thumbs", "close"],
      },
    },
    Zoomable: {
      Panzoom: {
        clickAction: "iterateZoom",
        maxScale: 2,
      },
    },
  },
  });
}

function setRatingValue(bar) {
  if (!bar) return;

  const rated = parseFloat(bar.dataset.rated) || 0;
  const percentage = (rated / 5) * 100; // 5 stars max
  const filled = bar.querySelector(".filled");

  if (filled) {
    filled.style.width = percentage + "%";
  }
}


document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".hb-ratingbar").forEach(setRatingValue);
  setRatingValue()
  initGalleryLightbox()
  initGallerySwiper()
});